export default "__VITE_ASSET__D0FZDz_8__"